var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new",on:{"click":_vm.toNew}},[_c('div',[_c('img',{attrs:{"src":_vm.info.img,"alt":"新闻图片"}})]),_c('div',[_c('div',{staticClass:"new-title"},[_vm._v(_vm._s(_vm.info.title))]),_c('p',{staticClass:"new-content"})])])}
var staticRenderFns = []

export { render, staticRenderFns }